<template>
  <section class="box-holder row">
    <div class="col-xs-12 col-md-6">
      <div class="box">
        <div class="box-header with-border" @click="detailsOpen = !detailsOpen">
          <h3 class="box-title">Document details</h3>
          <span class="pull-right"><i :class="[ detailsOpen ? 'open': '', 'ion ion-chevron-down' ]"></i></span>
        </div>
        <div :class="[ detailsOpen ? 'open': '', 'box-body' ]">
          <div class="form-group">
            <label for="ref" class="form-label">Ref</label>
            <input type="text" class="form-control" id="ref"/>
          </div>
          <div class="form-group">
            <label for="title" class="form-label">Title</label>
            <input type="text" class="form-control" id="title"/>
          </div>
          <div class="form-group">
            <label for="summary" class="form-label">Summary</label>
            <input type="text" class="form-control" id="summary"/>
          </div>
          <div class="form-group">
            <label for="section" class="form-label">Section</label>
            <select class="form-control" id="section">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="version" class="form-label">Version</label>
            <input type="text" class="form-control" id="version"/>
          </div>
          <div class="form-group">
            <label for="sequence" class="form-label">Sequence</label>
            <input type="text" class="form-control" id="sequence"/>
          </div>
          <div class="form-group">
            <label for="version-date" class="form-label">Version Date</label>
            <input type="text" class="form-control" id="version-date"/>
          </div>
          <div class="form-group">
            <label for="author" class="form-label">Author</label>
            <input type="text" class="form-control" id="author"/>
          </div>
          <div class="form-group">
            <label for="creator" class="form-label">Creator</label>
            <input type="text" class="form-control" id="creator"/>
          </div>
          <div class="form-group">
            <label for="publish-date" class="form-label">Publish Date</label>
            <input type="text" class="form-control" id="publish-date"/>
          </div>
          <div class="form-group">
            <label for="country" class="form-label">Specific to country</label>
            <select class="form-control" id="country">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="policy" class="form-label">Policy</label>
            <select class="form-control" id="policy">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="location" class="form-label">Specific to location</label>
            <input type="text" class="form-control" id="location"/>
          </div>
          <div class="form-group">
            <label for="tags" class="form-label">Tags</label>
            <input type="text" class="form-control" id="tags"/>
          </div>
          <div class="form-group">
            <label for="status" class="form-label">Status</label>
            <select class="form-control" id="status">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="box-header with-border" @click="contentOpen = !contentOpen">
          <h3 class="box-title">Content and Document Editor</h3>
          <span class="pull-right"><i :class="[ contentOpen ? 'open': '', 'ion ion-chevron-down' ]"></i></span>
        </div>
        <div :class="[ contentOpen ? 'open': '', 'box-body' ]">
          <blockquote>Documents</blockquote>
          <drop-file :styles="{ message: style }" :parentId="_uid" :uploadMessage="'Click or drop files here'"></drop-file>
          <div class="row file-area">
            <div class="col-xs-6 col-sm-4 col-lg-3" v-for="(file, i) in document.files">
              <file
                :name="file"
                :index="i"
                v-on:remove-file="removeFile"
                v-on:showing-file-options="closeFiles"
                :key="i"></file>
            </div>
          </div>
          <hr>
          <blockquote>Content editor</blockquote>
          <ckeditor v-model="testing" :config="config" :style="{ marginBottom: '10px' }"></ckeditor>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="box">
        <div class="box-header with-border" @click="accessOpen = !accessOpen">
          <h3 class="box-title">Access settings</h3>
          <span class="pull-right"><i :class="[ accessOpen ? 'open': '', 'ion ion-chevron-down' ]"></i></span>
        </div>
        <div :class="[ accessOpen ? 'open': '', 'box-body' ]">
          <div class="form-group">
            <label for="group-access" class="form-label">Allow group access?</label>
            <div class="material-switch">
              <input v-model="test" id="group-access" type="checkbox"/>
              <label for="group-access" class="label-success"></label>
            </div>
          </div>
          <div class="form-group">
            <label for="sub-group-access" class="form-label">Allow sub-group access?</label>
            <div class="material-switch">
              <input v-model="testTwo" id="sub-group-access" type="checkbox"/>
              <label for="sub-group-access" class="label-success"></label>
            </div>
          </div>
          <div class="form-group">
            <label for="entity" class="form-label">Entity</label>
            <input type="text" class="form-control" id="entity"/>
          </div>
          <div class="form-group">
            <label for="sub-group" class="form-label">Sub-Group</label>
            <select class="form-control" id="sub-group">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="business-unit" class="form-label">Business Unit</label>
            <select class="form-control" id="business-unit">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="employee-class" class="form-label">Employee Class</label>
            <select class="form-control" id="employee-class">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="grade" class="form-label">Grade</label>
            <select class="form-control" id="grade">
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="form-group">
            <label for="roles" class="form-label">Roles</label>
            <input type="text" class="form-control" id="roles"/>
          </div>
          <div class="form-group">
            <label for="service-provider" class="form-label">Service Provider</label>
            <input type="text" class="form-control" id="service-provider"/>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="box-header with-border" @click="miscOpen = !miscOpen">
          <h3 class="box-title">Thumbnail and Banner upload</h3>
          <span class="pull-right"><i :class="[ miscOpen ? 'open': '', 'ion ion-chevron-down' ]"></i></span>
        </div>
        <div :class="[ miscOpen ? 'open': '', 'box-body' ]">
          <blockquote>Add a thumbnail?</blockquote>
          <image-cropper :styles="{ message: style }" :parentId="_uid" :uploadMessage="'Click or drop an image here'"></image-cropper>
          <hr>
          <blockquote>Add a banner?</blockquote>
          <image-cropper :styles="{ message: style }" :aspectRatio="16/9" :parentId="_uid" :uploadMessage="'Click or drop an image here'"></image-cropper>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import ImageCropper from '../../helpers/ImageCropper.vue'
  import DropFile from '../../helpers/DropFile.vue'
  import File from './File.vue'
  import library from '../mixins/library'
  import Ckeditor from 'vue-ckeditor2'
  import ckconfig from '../../helpers/ckeditorconfig'
  export default {
    name: 'LibraryDocument',
    mixins: [library],
    components: {
      ImageCropper,
      Ckeditor,
      DropFile,
      File
    },
    data () {
      return {
        detailsOpen: true,
        accessOpen: true,
        contentOpen: false,
        miscOpen: false,
        test: true,
        testTwo: true,
        testing: '',
        style: {
          textTransform: 'uppercase',
          fontSize: '18px',
          fontWeight: 'bold'
        },
        config: ckconfig,
        document: {
          files: ['document.pdf', 'config.json', 'readme.md', 'important.pdf', 'operational-procedures.docx', 'something.zip', 'afile.rpt']
        }
      }
    },
    methods: {
      removeFile (data) {
        this.document.files.splice(data.index, 1)
        this.$emit('all-close', {})
      },
      closeFiles (data) {
        this.$emit('close-files', { index: data.index })
      }
    }
  }
</script>

<style scoped>
  .box-holder {
    padding: 20px;
  }
  .box-header {
    cursor: pointer;
  }
  .box-body {
    max-height: 0;
    transition: max-height 0.5s;
    overflow: hidden;
    padding-bottom: 0 !important;
  }
  .box-body.open {
    max-height: 2000px;
  }
  .ion-chevron-down {
    transition: transform 0.5s;
  }
  .ion-chevron-down.open {
    transform: rotate(90deg);
  }
  .file-area {
    padding: 10px;
    background: #ecf0f5;
    margin: 0;
  }
  hr {
    margin: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/modules/library/components/LibraryDocument.vue